
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
  postApprove,
  getDeliveryPlan,
  checkCancelOutbound,
} from "@/api/closing-order";
import { getRecipients } from "@/api/mails";
import {
  getClosureType,
  getclosureOrderApprove,
  invalidClosureOrder,
  postPendingDialog,
  postExecuteTime
} from "@/api/closing-order";
// chooseCanCancel
// putChooseCanCancel
// import {
//   searchCustomer
// } from "@/api/customer";
@Component({
  name: "reviewClosingOrders",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private canCancel = false;
  private showExamineDialog = false;
  private showCancelDialog = false;
  private showPendingDialog = false;
  private ExamineDialogDialogContent = "";
  private CancelDialogContent = "";
  private PendingDialogDialogContent = "";
  public deliveryState = false
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any,
  };
  private listParam = {
    createStartTime: null,
    createEndTime: null,
    code: null,
    type: null,
    // relationType: null,
    relationCode: null,
    createId: null,
    handlerId: null,
    state: null,
    executeStartTime: null,
    executeEndTime: null
  };
  public deliveryPlan = false;
  private searchForm = [
    {
      label: "查找平仓单",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
    },
    {
      label: "创建时间",
      prop: "time",
      key: "time",
      type: "datePicker",
      value: "",
      valueFormat: "yyyy-MM-dd"
    },
    {
      label: "关联装箱单",
      prop: "relationCode",
      key: "relationCode",
      type: "input",
      value: "",
    },
    {
      label: "处理人",
      prop: "handlerId",
      key: "handlerId",
      type: "select",
      value: "",
      clearable: true,
      options: [],
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "创建人",
      prop: "createId",
      key: "createId",
      type: "select",
      value: "",
      clearable: true,
      options: [],
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "审核状态",
      prop: "state",
      key: "state",
      type: "select",
      value: "",
      placeholder: "",
      disabled: false,
      clearable: true,
      options: [
        {
          label: "待审核",
          value: "APPROVE",
        },
        {
          label: "已挂起",
          value: "PENDING",
        },
        {
          label: "审核通过",
          value: "FINISH",
        },
        {
          label: "审核人作废",
          value: "INVALID_BY_APPROVAL",
        },
      ],
      resetKey: { label: "label", value: "value" },
    },
    {
      label: "平仓原因",
      prop: "type",
      key: "type",
      type: "select",
      value: "",
      placeholder: "请选择平仓原因",
      clearable: true,
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "执行时间",
      prop: "executeTime",
      key: "executeTime",
      type: "datePicker",
      value: "",
      valueFormat: "yyyy-MM-dd"
    },
  ];
  private tableCol = [
    {
      label: "平仓单编号",
      prop: "code",
      key: "code",
      type: "link",
      show: true,
      disabled: false,
    },
    {
      label: "关联装箱单",
      prop: "relationCode",
      key: "relationCode",
      show: true,
      disabled: false,
    },
    {
      label: "平仓原因",
      prop: "typeDesc",
      key: "typeDesc",
      show: true,
      disabled: false,
    },
    {
      label: "创建人",
      prop: "handlerName",
      key: "handlerName",
      show: true,
      disabled: false,
    },
    {
      label: "处理人",
      prop: "approveName",
      key: "approveName",
      show: true,
      disabled: false,
    },
    {
      label: "审核状态",
      prop: "stateDesc",
      key: "stateDesc",
      show: true,
      disabled: false,
    },
    {
      label: "执行时间",
      prop: "executeTime",
      key: "executeTime",
      show: true,
      disabled: false,
    },
    {
      label: "平仓说明",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "创建时间",
      prop: "createdAt",
      key: "createdAt",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "审核",
          code: "",
          click: "handleExamine",
          key: 'state',
          value: 'APPROVE,PENDING'
        },
        {
          name: "作废",
          code: "",
          click: "handleCancel",
          key: 'state',
          value: 'APPROVE,PENDING'
        },
        {
          name: "查看平仓",
          code: "",
          click: "lookClosing",
        },
        {
          name: "挂起",
          code: "",
          click: "handlePending",
          key: 'state',
          value: 'APPROVE'
        },
        {
          name: "执行",
          code: "",
          click: "handelExecute",
          key: 'state',
          value: 'FINISH'
        },
        // {
        //   name: "取消挂起",
        //   code: '',
        //   click: "",
        // }
      ],
      show: true,
      disabled: false,
      width: 200,
    },
  ] as any;
  private executeTime = '';
  mounted() {
    this.init();
  }
  private init() {
    this.searchCustomer();
    this.getList();
    this.getClosureType();
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    const { total, content }: any = await getclosureOrderApprove(params);
    this.table.total = +total;
    content.map((e) => {
      e.approveName = e.approve ? e.approve.name : null;
      e.handlerName = e.handler ? e.handler.name : null;
      e.relationCode = e.relateOrders
        ? e.relateOrders.filter(e => e.orderType === 'HQ_PACKING_LIST')
            .map((ut) => {
              return ut.code;
            })
            .toString()
        : null;
    });
    this.loading = false;
    this.table.list = content;
    // this.table.list.map(item => {
    //   if(item.executeTime) {
    //     item.executeTime = '已执行\n' + item.executeTime
    //   }
    // })
  }
  public querySearch(data) {
    this.listParam = data && data !== "reset" ? data : {};
    if (data.time && data.time.length) {
      this.listParam.createStartTime = data.time[0];
      this.listParam.createEndTime = data.time[1];
    }
    if (data.executeTime && data.executeTime.length) {
      this.listParam.executeStartTime = data.executeTime[0];
      this.listParam.executeEndTime = data.executeTime[1];
    }
    delete data.time;
    delete data.executeTime;
    this.getList();
  }
  private handleCancel(row) {
    // 作废平仓单
    this.selectId = row.row.id;
    this.showCancelDialog = true;
  }

  private selectId = null;
  private examineId = null;
  private showOrderType = '';

  private async handleExamine(e) {
    this.selectId = e.row.id;
    // 审核平仓单
    const { orderId, orderType } = e.row.relateOrders[0];
    this.deliveryPlan = false;
    this.showExamineDialog = true;
    this.showOrderType = orderType;
    if (orderType === "HENG_AN_LOADING_PLAN") {
      this.examineId = orderId;
      const res:any =  await getDeliveryPlan(orderId);
      console.log('res',res)
      if(res === 1) {
        this.deliveryPlan = false
      } else if(res === 2) {
        this.deliveryPlan = true
      }
    }
  }
  public async selectdelivery(e) {
    this.deliveryState = e
    // await checkCancelOutbound(this.examineId, { canCancel: e });
  }
  private postPendingDialog() {
    this.$confirm("确定挂起平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await postPendingDialog(this.selectId)
          .then(() => {
            // this.showPendingDialog = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private showExecute = false;
  private executeId = "";
  private handelExecute(row) {
    this.executeTime = '';
    this.showExecute = true;
    this.executeId = row.row.id
    if(row.row.executeTime) {
      this.executeTime = row.row.executeTime
    }
  }
  private async postExecuteTime() {
    let data = {
      id: this.executeId,
      executeTime: this.executeTime
    }
    await postExecuteTime(data).then(res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
      this.showExecute = false;
    }).catch(err => {
      console.log(err)
    })
  }

  private async postApprove() {
    this.$confirm("确定审核平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let data = {
          id: this.selectId,
          reason: this.ExamineDialogDialogContent,
        };
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if(this.deliveryPlan) {
          await checkCancelOutbound(this.examineId, { canCancel: this.deliveryState }).then(async()=>{
            await postApprove(data)
            .then(() => {
              this.showExamineDialog = false;
              this.$notify({
                title: "成功",
                message: "操作成功",
                type: "success",
                duration: 2000,
              });
              this.getList();
              loading.close();
            })
            .catch((err) => {
              console.log(err);
              loading.close();
            });
          })
        } else {
          await postApprove(data)
          .then(() => {
            this.showExamineDialog = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
            loading.close();
          })
          .catch((err) => {
            console.log(err);
            loading.close();
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async getRecipients() {
    const res: any = (await getRecipients({ pushType: "USER_PUSH" })) as any;
    this.searchForm[3].options = res;
    this.searchForm[4].options = res;
  }

  private getClosureTypeList = [];
  private async getClosureType() {
    const res: any = await getClosureType();
    this.searchForm[
      this.searchForm.findIndex((e) => e.key === "type")
    ].options = res;
    this.getClosureTypeList = res;
  }

  private linkClick(scope) {
    this.$router.push(
      `/closingPositionDetail?id=${scope.row.id}&type=${scope.row.type}`
    );
  }

  private cancelSubmit() {
    this.$confirm("确定作废平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let data = {
          id: this.selectId,
          reason: this.CancelDialogContent,
        };
        await invalidClosureOrder(data)
          .then(() => {
            this.showCancelDialog = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handlePending(row) {
    // 挂起平仓单
    this.selectId = row.row.id;
    // this.showPendingDialog = true;
    this.postPendingDialog();
  }
  private async searchCustomer() {
    const res: any = (await getRecipients({ pushType: "USER_PUSH" })) as any;
    this.searchForm[3].options = res;
    this.searchForm[4].options = res;
  }
}
